import axios, {AxiosPromise} from "axios"
import {getEasasRestUrl} from "utils/utils";
import {QueryClient} from "react-query";
import {easasAlert} from "../components/fragments/easas-global-fragment/EasasGlobalAlerts";
import {checkPermission} from "../hooks/useHasPermissions";

export const paramsSerializer = (params: any) => {
    return Object.keys(params)
        .map(key => {
            const value = params[key];
            if (value !== undefined) {
                if (Array.isArray(value)) {
                    // Convert array values to single value
                    return value.map((val: any) => `${key}=${encodeURIComponent(val)}`).join('&');
                } else {
                    return `${key}=${encodeURIComponent(value)}`;
                }
            }
            return '';
        })
        .filter(param => param !== '')
        .join('&');
};

export const easasAxios = function () {
    const client = axios.create({
        baseURL: getEasasRestUrl(),
        paramsSerializer: {serialize: paramsSerializer}
    });

    client.interceptors.response.use(
        (response) => {
            if (checkPermission("SUPER_USER")) {
                easasAlert("Request successful")
            }
        // Do something with response data
        return response;
    }, (error) => {
        // Do something with response error
        if(error.response?.status == 401) {
            easasAlert("Session timed out", "Please re-login by refreshing the page.", "error");
        } else if (error.response?.status == 403) {
            easasAlert("Access denied", "You tries accessing restricted resource", "warn");
        } else {
            if (checkPermission("ADMIN")) {
                easasAlert("Network error (internal)", error.response?.data?.message, "error")
            }
        }

        return Promise.reject(error);
    });


    return client
}()

export const queryClient = new QueryClient();

export type Info = { headers?: Record<string, any>; code?: number };

export type APIResponse<T> = {data?: T, error?: Error, info?: Info};

export type APIPromise<T> = Promise<APIResponse<T>>;


export function requestPromiseTypeWrapper<T>(promise: AxiosPromise<T>, objMapperFn?: (data: Partial<T>) => T): APIPromise<T> {
    return promise.then((res) => {
        if(objMapperFn) {
            return ({data: objMapperFn(res.data)});
        } else {
            return {data: res.data};
        }
    }).catch((error: any) => {
        return {error: error.response?.data};
    })
}